import React, { useState, useEffect, useRef } from "react";
import smGif from "../img/sm-gif.avifs"; // GIF dosyasının yolu
import smStatic from "../img/sm-static.avif";
import smbg from "../img/sm-bg.avif";
import arrow from "../img/arrow-narrow-right-svgrepo-com.svg";
import smMobileStatic from "../img/sm-mobile.avif";
import smMobileGif from "../img/sm-mobile.avifs";
import { Link as ScrollLink } from "react-scroll";
import mobileBg from "../img/mobilebg.avif";

function Sm() {
  const [isGifVisible, setGifVisible] = useState(true); // İlk olarak true yapıldı
  const [isTriggered, setIsTriggered] = useState(false); // Bileşenin bir kere tetiklenip tetiklenmediğini takip etmek için yeni bir durum
  const smRef = useRef();
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);
  const [isBg, setIsBg] = useState(true);
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    // İlk yüklemede GIF'i gizlemek için bir zamanlayıcı
    const initialTimer = setTimeout(
      () => {
        setGifVisible(false);
      },
      isMobile ? 4600 : 4525
    );

    return () => clearTimeout(initialTimer);
  }, [isMobile]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isTriggered) {
            setGifVisible(true);
            setIsOverlayVisible(true);
            setIsTriggered(true); // Bir kere tetiklendikten sonra true yap
            setIsBg(false);
            const timerSm = setTimeout(
              () => {
                setGifVisible(false);
              },
              isMobile ? 4600 : 4525
            );
            return () => clearTimeout(timerSm);
          }
        });
      },
      { threshold: 0.5 } // %30 görünürlük sağlandığında tetikler
    );
    const currentRef = smRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [isTriggered, isMobile]);

  return (
    <div
      ref={smRef}
      id="social-media"
      className="relative w-full mobile:bg-pulpMobileGray mobile:h-auto tablet:h-[50vh] lg:h-[100vh]"
    >
      <img
        src={isMobile ? mobileBg : smbg}
        alt="Background"
        className="absolute inset-0 w-full h-full object-cover z-30"
        style={{ display: isBg ? "block" : "none" }}
      />
      <div className="container ml-auto mr-auto">
        <img
          src={isMobile ? smMobileGif : smGif}
          alt="GIF"
          className={`mobile:relative absolute inset-0 tablet:object-center w-full mobile:h-[40vh] mobile:object-cover mobile:object-left tablet:object-cover h-full object-cover 2xl:object-cover z-10 ${
            isGifVisible ? "opacity-100" : "opacity-0"
          }`}
          style={{ display: isGifVisible ? "block" : "none" }}
        />
        <img
          src={isMobile ? smMobileStatic : smStatic}
          alt="Static"
          className={`mobile:relative absolute inset-0 tablet:object-center w-full mobile:h-[40vh] mobile:object-left mobile:object-cover mobile:object- tablet:object-cover h-full object-cover 2xl:object-cover z-20 ${
            isGifVisible ? "opacity-0" : "opacity-100"
          }`}
          style={{ display: isGifVisible ? "none" : "block" }}
        />
        <div
          className={`mobile:relative absolute mobile:w-5/6 z-40 container mobile:py-0 mobile:h-full md:mr-10 mobile:inset-0 lg:mr-10 2xl:mr-auto mr-auto ml-auto inset-0 flex flex-col items-right justify-center mobile:mt-5 mt-20 p-4 duration-1000 transform ${
            isOverlayVisible ? "opacity-100" : "opacity-0"
          }`}
        >
          <div>
            <h3 className="text-orange-400 mobile:text-right mobile:text-lg tablet:text-lg text-right text-2xl xl:text-2xl 2xl:text-3xl font-semibold">
              works
            </h3>
          </div>
          <div>
            <h2 className="text-white font-semibold mobile:text-right mobile:text-3xl tablet:text-3xl lg:text-3xl xl:text-5xl hd:text-5xl 2xl:text-8xl text-right">
              Social Media <br className="mobile:hidden" /> Management
            </h2>
          </div>
          <div className="tablet:mt-5 mobile:mt-5 mt-10 mobile:w-full w-1/3 ml-auto font-medium">
            <p className="text-white mobile:ml-auto mobile: mobile:mb-2 mobile:text-xs tablet:text-sm mobile:text-right text-right">
              We turn your brand’s social media into a growth system. <br />
              Built to drive traction, trust, and long-term value.
            </p>
          </div>
          <div className="relative mobile:mt-5 mt-10">
            <ScrollLink to="contact" smooth={true} duration={500}>
              <button className="flex ml-auto mobile:w-full mobile:bg-orange-400 tablet:text-sm tablet:p-2 rounded-full w-auto font-semibold mobile:mt-2 bg-none border-orange-400 border-solid border-2 text-white py-2 text-sm lg:text-base 2xl:text-base px-5 mobile:text-base mobile:p-2 mobile:text-center items-center mobile:justify-center justify-end">
                Schedule a Consultation
                <img
                  className="mobile:hidden"
                  src={arrow}
                  width={"45px"}
                  height={"45px"}
                  alt=""
                />
              </button>
            </ScrollLink>
          </div>

          <div className="flex mobile:scale-75 mobile:ml-auto mobile:mt-10 mobile:w-full tablet:w-1/4 w-1/3 h-24 2xl:h-28 mt-7 ml-auto mobile:justify-center justify-end">
            <div className="border-r-2 mobile:px-5 mobile:h-auto tablet:h-16 pr-5 border-orange-300">
              <h1 className="text-4xl mobile:font-bold mobile:text-left mobile:text-3xl 2xl:text-5xl tablet:text-3xl text-white">
                1B+
              </h1>
              <p className="text-base mobile:text-left tablet:text-xs mobile:text-lg mt-1 text-left font-normal text-orange-300">
                Organic <br /> Impressions <br /> Delivered
              </p>
            </div>
            <div className="border-r-2 mobile:px-10 mobile:h-auto tablet:h-16 h-24 2xl:h-28 px-5 text-left border-orange-300">
              <h1 className="text-4xl mobile:font-bold mobile:text-left mobile:text-3xl 2xl:text-5xl tablet:text-3xl text-white">
                60+
              </h1>
              <p className="text-base mobile:text-left tablet:text-xs mobile:text-lg mt-1 text-left font-normal text-orange-300">
                Active
                <br />
                Clients
              </p>
            </div>
            <div className="border-orange-300 mobile:px-5 mobile:h-auto tablet:h-16 pl-5 h-24 2xl:h-28">
              <h1 className="text-4xl mobile:font-bold mobile:text-left mobile:text-3xl 2xl:text-5xl tablet:text-3xl text-white">
                x4
              </h1>
              <p className="text-base mobile:text-left tablet:text-xs mobile:text-lg mt-1 text-left font-normal text-orange-300">
                Average
                <br />
                Engagement
                <br />
                Rate
              </p>
            </div>
          </div>

          <div className="hidden mobile:block mt-7 mb-12 w-full h-1 bg-pulpPurple rounded-full mx-auto"></div>
        </div>
      </div>
    </div>
  );
}

export default Sm;
